import { Component, inject } from '@angular/core';
import { formControl, Validators } from '@al00x/forms';
import {
  ButtonClickEvent,
  CacBaseDialogComponent,
  CacDialogLayoutComponent,
  CacFormBuilderComponent,
  formBuilder,
} from '@controladad/ng-base';
import { AreaEntity } from '@models';
import { GovernorateApiService } from '../../../services';
import { extractName } from '../../../helpers';

export interface AreaDialogData {
  area?: AreaEntity;
  governorateId: number;
}

export type AreaDialogResult = boolean;

@Component({
  selector: 'lib-area-dialog',
  imports: [CacDialogLayoutComponent, CacFormBuilderComponent],
  templateUrl: './area-dialog.component.html',
  styleUrl: './area-dialog.component.scss',
})
export class AreaDialogComponent extends CacBaseDialogComponent<AreaDialogData, AreaDialogResult> {
  private readonly governorateApi = inject(GovernorateApiService);

  form = formBuilder({
    cols: 1,
    inputs: {
      englishName: {
        control: formControl<string>(this.data?.area?.name?.english, Validators.required),
        label: 'English Name',
      },
      arabicName: {
        control: formControl<string>(this.data?.area?.name?.arabic, Validators.required),
        label: 'Arabic Name',
      },
    },
  });

  onSubmit(e: ButtonClickEvent) {
    const value = this.form.getValue();
    const area = this.data.area;

    if (!value) return;

    const fields = {
      name: extractName(value),
      governorateId: this.data.governorateId
    };

    const request = area
      ? this.governorateApi.updateArea({ areaId: area.id, fields })
      : this.governorateApi.createArea({ fields });

    return request.pipe(e.pipe()).subscribe(() => this.submit(true));
  }
}
